/* ==========================================================================
   Foto vergroten op de productpagina
   Klik of tik op een productfoto en die gaat schermvullend open. Daarna:
     - dubbelklik / dubbeltik  -> in- en uitzoomen
     - knijpen (twee vingers)  -> vrij zoomen
     - scrollwiel              -> zoomen op de plek van de cursor
     - slepen                  -> pannen zolang je ingezoomd bent
     - vegen                   -> vorige/volgende foto (als je niet ingezoomd bent)
     - veeg omlaag / Esc / tik naast de foto -> sluiten

   Hoort bij assets/pdp-lightbox.css. Los van pdp-main.js gehouden: de galerij
   daar (scroll-snap track, miniaturen, teller) blijft ongewijzigd werken, ook
   als dit bestand niet laadt.

   Labels komen uit data-attributen op de galerij, zodat Translate & Adapt ze
   per market kan vertalen. Geen vaste Nederlandse tekst in dit bestand.
   ========================================================================== */
(function () {
  'use strict';

  var galerij = document.querySelector('[data-pdp-gallery]');
  if (!galerij) return;

  // Alleen echte foto's. Video's en 3D-modellen krijgen geen data-pdp-full en
  // blijven dus gewoon in de pagina staan.
  var bronnen = [].slice.call(galerij.querySelectorAll('[data-pdp-slide] img[data-pdp-full]'));
  if (!bronnen.length) return;

  var items = bronnen.map(function (img) {
    var slide = img.closest('[data-pdp-slide]');
    return {
      vol: img.getAttribute('data-pdp-full'),
      klein: img.currentSrc || img.src,
      alt: img.getAttribute('alt') || '',
      slide: slide ? slide.getAttribute('data-pdp-slide') : null,
      bron: img
    };
  });

  var tekst = {
    sluiten: galerij.getAttribute('data-lb-close') || '',
    vorige: galerij.getAttribute('data-lb-prev') || '',
    volgende: galerij.getAttribute('data-lb-next') || '',
    vergroten: galerij.getAttribute('data-lb-zoom') || ''
  };

  // Vanaf hier weten we dat er iets te vergroten valt; dan mag het lensje in
  // de hoek staan. Zonder JavaScript blijft die aanwijzing weg.
  galerij.classList.add('pdp-gallery--lb');

  /* ------------------------------------------------------------------------
     Opbouw van de laag. Pas bij de eerste klik, zodat een bezoeker die nooit
     op een foto klikt er ook geen DOM voor krijgt.
     ---------------------------------------------------------------------- */
  var laag = null, speelveld, foto, spinner, knopVorige, knopVolgende, teller;

  function knop(klasse, label, pad) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = klasse;
    if (label) b.setAttribute('aria-label', label);
    b.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + pad + '</svg>';
    return b;
  }

  function bouw() {
    laag = document.createElement('div');
    laag.className = 'pdp-lb';
    laag.setAttribute('role', 'dialog');
    laag.setAttribute('aria-modal', 'true');
    if (tekst.vergroten) laag.setAttribute('aria-label', tekst.vergroten);

    speelveld = document.createElement('div');
    speelveld.className = 'pdp-lb__stage';

    foto = document.createElement('img');
    foto.className = 'pdp-lb__img';
    foto.setAttribute('draggable', 'false');
    speelveld.appendChild(foto);

    spinner = document.createElement('div');
    spinner.className = 'pdp-lb__spinner';
    speelveld.appendChild(spinner);

    laag.appendChild(speelveld);

    var sluit = knop('pdp-lb__close', tekst.sluiten, '<line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/>');
    sluit.addEventListener('click', sluiten);
    laag.appendChild(sluit);
    laag.sluitKnop = sluit;

    if (items.length > 1) {
      knopVorige = knop('pdp-lb__nav pdp-lb__nav--prev', tekst.vorige, '<polyline points="15 18 9 12 15 6"/>');
      knopVolgende = knop('pdp-lb__nav pdp-lb__nav--next', tekst.volgende, '<polyline points="9 18 15 12 9 6"/>');
      knopVorige.addEventListener('click', function () { stap(-1); });
      knopVolgende.addEventListener('click', function () { stap(1); });
      laag.appendChild(knopVorige);
      laag.appendChild(knopVolgende);

      teller = document.createElement('div');
      teller.className = 'pdp-lb__count';
      laag.appendChild(teller);
    }

    // Let op: géén click-afhandeling om "naast de foto tikken sluit" te doen.
    // Tijdens een sleep of knijpbeweging vangt het speelveld de aanwijzer op
    // (setPointerCapture), en een browser mag de bijbehorende click dan aan het
    // opvangende element toewijzen in plaats van aan de foto. Dan zou een tik
    // óp de foto de laag sluiten. We beslissen daarom zelf, op basis van de
    // plek van de tik ten opzichte van de foto — zie buitenDeFoto().
    document.body.appendChild(laag);
    hangGebarenOp();
  }

  /* ------------------------------------------------------------------------
     Zoom- en sleeptoestand
     De foto staat via flexbox in het midden van het speelveld. De transform is
     translate(t) scale(s) met het midden als oorsprong, dus een punt u van de
     onvergrote foto (gemeten vanaf haar midden) komt op het scherm terecht op
        C + t + s * u        met C = het midden van het speelveld.
     Wil je bij zoomen een punt F onder de vinger houden, dan volgt daaruit
        t' = d - (s'/s) * (d - t)   met d = F - C.
     ---------------------------------------------------------------------- */
  var index = 0, schaal = 1, tx = 0, ty = 0;
  var MAX = 4, geopend = false, laatstGeklikt = null;

  function veldMidden() {
    var r = speelveld.getBoundingClientRect();
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }

  function buitenDeFoto(x, y) {
    var r = foto.getBoundingClientRect();
    return x < r.left || x > r.right || y < r.top || y > r.bottom;
  }

  function beperk() {
    // Hoe ver mag het midden van de foto van het midden van het veld af? Net
    // zo ver dat de rand van de foto de rand van het veld raakt, niet verder.
    var b = foto.offsetWidth * schaal, h = foto.offsetHeight * schaal;
    var maxX = Math.max(0, (b - speelveld.clientWidth) / 2);
    var maxY = Math.max(0, (h - speelveld.clientHeight) / 2);
    tx = Math.min(maxX, Math.max(-maxX, tx));
    ty = Math.min(maxY, Math.max(-maxY, ty));
  }

  function teken() {
    beperk();
    foto.style.transform = 'translate3d(' + tx.toFixed(1) + 'px,' + ty.toFixed(1) + 'px,0) scale(' + schaal.toFixed(4) + ')';
    laag.classList.toggle('is-zoomed', schaal > 1.01);
  }

  function zetSchaal(nieuw, focusX, focusY, zacht) {
    nieuw = Math.min(MAX, Math.max(1, nieuw));
    if (Math.abs(nieuw - schaal) < 0.001) return;

    var c = veldMidden();
    var dx = (focusX === undefined ? c.x : focusX) - c.x;
    var dy = (focusY === undefined ? c.y : focusY) - c.y;
    var f = nieuw / schaal;
    tx = dx - f * (dx - tx);
    ty = dy - f * (dy - ty);
    schaal = nieuw;
    if (nieuw === 1) { tx = 0; ty = 0; }

    zachtTekenen(zacht);
  }

  function zachtTekenen(zacht) {
    if (zacht) {
      foto.classList.add('is-animating');
      window.setTimeout(function () { foto.classList.remove('is-animating'); }, 220);
    }
    teken();
  }

  /* ------------------------------------------------------------------------
     Foto's tonen
     ---------------------------------------------------------------------- */
  function laad(i) {
    var it = items[i];
    schaal = 1; tx = 0; ty = 0;
    foto.classList.remove('is-animating');
    foto.style.transform = '';
    laag.classList.remove('is-zoomed');
    foto.alt = it.alt;

    if (it.geladen) {
      foto.src = it.vol;
    } else {
      // Eerst de versie die al in de pagina staat: die is er meteen, dus je
      // ziet nooit een leeg vlak. Daarna in stilte de grote erover.
      foto.src = it.klein;
      laag.classList.add('is-loading');
      var groot = new Image();
      groot.onload = function () {
        it.geladen = true;
        if (index === i && geopend) {
          foto.src = it.vol;
          teken();
        }
        laag.classList.remove('is-loading');
      };
      groot.onerror = function () { laag.classList.remove('is-loading'); };
      groot.src = it.vol;
    }

    if (teller) teller.textContent = (i + 1) + '/' + items.length;
    if (knopVorige) knopVorige.hidden = i === 0;
    if (knopVolgende) knopVolgende.hidden = i === items.length - 1;

    // Buren vooruit ophalen, dan is doorbladeren direct.
    [i - 1, i + 1].forEach(function (n) {
      var b = items[n];
      if (b && !b.geladen) { var v = new Image(); v.onload = function () { b.geladen = true; }; v.src = b.vol; }
    });
  }

  function stap(richting) {
    var n = index + richting;
    if (n < 0 || n >= items.length) return;
    index = n;
    laad(index);
  }

  function openen(i, vanaf) {
    if (!laag) bouw();
    index = i;
    laatstGeklikt = vanaf || null;
    geopend = true;
    laad(index);
    document.documentElement.classList.add('pdp-lb-open');
    document.body.classList.add('pdp-lb-open');

    // Bewust géén requestAnimationFrame om de overgang te laten aanslaan: in een
    // tabblad dat niet rendert (achtergrond, of throttling) vuurt die callback
    // niet, en dan staat de pagina wél op slot terwijl de laag onzichtbaar
    // blijft. Eén gedwongen herberekening legt de begintoestand net zo goed
    // vast, en gebeurt altijd.
    void laag.offsetWidth;
    laag.classList.add('is-open');
    laag.sluitKnop.focus({ preventScroll: true });
  }

  function sluiten() {
    if (!geopend) return;
    geopend = false;
    laag.classList.remove('is-open');
    document.documentElement.classList.remove('pdp-lb-open');
    document.body.classList.remove('pdp-lb-open');

    // De galerij in de pagina meenemen naar de foto waar je op geëindigd bent.
    // Dat gaat via de miniatuur: die heeft in pdp-main.js al een klikafhandeling
    // die naar de juiste plek in de track springt.
    var slide = items[index].slide;
    if (slide !== null) {
      var mini = galerij.querySelector('[data-pdp-thumb="' + slide + '"]');
      if (mini && mini.getAttribute('aria-current') !== 'true') mini.click();
    }
    if (laatstGeklikt) laatstGeklikt.focus({ preventScroll: true });
  }

  /* ------------------------------------------------------------------------
     Gebaren
     ---------------------------------------------------------------------- */
  function hangGebarenOp() {
    var actief = {};          // aanwijzers die op dit moment op het veld staan
    var start = null;         // begintoestand van een sleep of knijpbeweging
    var laatsteTik = 0, laatsteTikX = 0, laatsteTikY = 0;
    var soort = 'mouse';      // aanwijzersoort van de laatste aanraking

    function aantal() { return Object.keys(actief).length; }
    function tweeStanden() {
      var ids = Object.keys(actief);
      return [actief[ids[0]], actief[ids[1]]];
    }

    speelveld.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      soort = e.pointerType || 'mouse';
      actief[e.pointerId] = { x: e.clientX, y: e.clientY };
      try { speelveld.setPointerCapture(e.pointerId); } catch (err) { /* niet fataal */ }

      if (aantal() === 1) {
        start = { x: e.clientX, y: e.clientY, tx: tx, ty: ty, schaal: schaal, tijd: Date.now(), bewogen: false, knijp: false };
      } else if (aantal() === 2) {
        var p = tweeStanden();
        start = {
          knijp: true,
          bewogen: true,
          afstand: Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y),
          midX: (p[0].x + p[1].x) / 2,
          midY: (p[0].y + p[1].y) / 2,
          tx: tx, ty: ty, schaal: schaal
        };
      }
    });

    speelveld.addEventListener('pointermove', function (e) {
      if (!actief[e.pointerId] || !start) return;
      actief[e.pointerId] = { x: e.clientX, y: e.clientY };

      if (start.knijp && aantal() >= 2) {
        var p = tweeStanden();
        var nu = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
        if (!start.afstand) return;
        // Terugrekenen vanaf de begintoestand, niet stapje voor stapje: dan
        // loopt er geen afrondingsfout op tijdens een lang gebaar.
        schaal = start.schaal; tx = start.tx; ty = start.ty;
        zetSchaal(start.schaal * (nu / start.afstand), start.midX, start.midY, false);
        return;
      }

      var dx = e.clientX - start.x, dy = e.clientY - start.y;
      if (!start.bewogen && Math.hypot(dx, dy) > 6) start.bewogen = true;

      if (schaal > 1.01) {
        // Ingezoomd: slepen pant de foto.
        laag.classList.add('is-panning');
        tx = start.tx + dx;
        ty = start.ty + dy;
        teken();
      }
    });

    function omhoog(e) {
      if (!actief[e.pointerId]) return;
      var wasKnijp = start && start.knijp;
      delete actief[e.pointerId];
      laag.classList.remove('is-panning');

      if (aantal() === 1 && wasKnijp) {
        // Eén vinger blijft staan na een knijpbeweging: verder als sleep.
        var over = tweeStanden()[0];
        start = { x: over.x, y: over.y, tx: tx, ty: ty, schaal: schaal, tijd: Date.now(), bewogen: true, knijp: false };
        return;
      }
      if (aantal() > 0 || !start) return;

      var dx = e.clientX - start.x, dy = e.clientY - start.y;
      var kort = Date.now() - start.tijd < 350;

      if (!wasKnijp && schaal <= 1.01 && !start.knijp) {
        if (start.bewogen && Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          stap(dx < 0 ? 1 : -1);           // vegen: volgende / vorige
          start = null;
          return;
        }
        if (start.bewogen && dy > 90 && Math.abs(dy) > Math.abs(dx) * 1.4) {
          sluiten();                       // veeg omlaag
          start = null;
          return;
        }
      }

      if (!start.bewogen && kort) {
        // Tik naast de foto sluit; tik óp de foto is de eerste helft van een
        // mogelijke dubbeltik en doet in zijn eentje niets.
        if (buitenDeFoto(e.clientX, e.clientY)) { sluiten(); start = null; return; }

        var nu = Date.now();
        var dubbel = nu - laatsteTik < 300 &&
                     Math.hypot(e.clientX - laatsteTikX, e.clientY - laatsteTikY) < 32;
        if (dubbel) {
          zetSchaal(schaal > 1.01 ? 1 : 2.5, e.clientX, e.clientY, true);
          laatsteTik = 0;
        } else {
          laatsteTik = nu; laatsteTikX = e.clientX; laatsteTikY = e.clientY;
        }
      }
      start = null;
    }

    speelveld.addEventListener('pointerup', omhoog);
    speelveld.addEventListener('pointercancel', function (e) {
      delete actief[e.pointerId];
      laag.classList.remove('is-panning');
      if (!Object.keys(actief).length) start = null;
    });

    // Scrollwiel zoomt op de plek van de cursor. passive: false, want we
    // moeten het doorscrollen van de pagina eronder tegenhouden.
    speelveld.addEventListener('wheel', function (e) {
      e.preventDefault();
      var stapje = Math.exp(-e.deltaY * (e.deltaMode === 1 ? 0.05 : 0.0022));
      zetSchaal(schaal * stapje, e.clientX, e.clientY, false);
    }, { passive: false });

    // Dubbelklik met de muis. Op een aanraakscherm vuurt dit óók (Chrome doet
    // dat bij een dubbeltik zodra touch-action het browserzoomen tegenhoudt) en
    // dan zou de foto meteen weer uitzoomen: één keer via de tikteller
    // hierboven, één keer hier. Vandaar de soort-controle.
    speelveld.addEventListener('dblclick', function (e) {
      if (soort === 'touch') return;
      zetSchaal(schaal > 1.01 ? 1 : 2.5, e.clientX, e.clientY, true);
    });

    window.addEventListener('resize', function () {
      if (!geopend) return;
      // Na een draai van het toestel kan de foto scheef hangen; terug naar het
      // midden is dan eerlijker dan een halve pan bewaren.
      if (schaal <= 1.01) { tx = 0; ty = 0; }
      teken();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (!geopend) return;
    if (e.key === 'Escape') { e.preventDefault(); sluiten(); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); stap(-1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); stap(1); }
    else if (e.key === '+' || e.key === '=') { zetSchaal(schaal * 1.4, undefined, undefined, true); }
    else if (e.key === '-') { zetSchaal(schaal / 1.4, undefined, undefined, true); }
    else if (e.key === 'Tab' && !laag.contains(document.activeElement)) {
      // Geen volledige focusval, maar de focus mag niet ongemerkt achter de
      // laag verdwijnen: daar is met het toetsenbord niets te doen.
      e.preventDefault();
      laag.sluitKnop.focus({ preventScroll: true });
    }
  });

  /* ------------------------------------------------------------------------
     De klik in de pagina zelf
     ---------------------------------------------------------------------- */
  items.forEach(function (it, i) {
    it.bron.addEventListener('click', function (e) {
      e.preventDefault();
      openen(i, it.bron);
    });
    // De foto's zitten niet in een link; zonder dit zijn ze niet met het
    // toetsenbord te bereiken. Bewust géén role="button": dan verliest een
    // schermlezer de alt-tekst met de productbeschrijving. De title vertelt
    // muisgebruikers bij het zweven wat een klik doet.
    it.bron.setAttribute('tabindex', '0');
    if (tekst.vergroten) it.bron.setAttribute('title', tekst.vergroten);
    it.bron.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openen(i, it.bron); }
    });
  });
})();
